import React from "react";

function TournamentZoomControls({ zoomLevel, onZoomIn, onZoomOut, nightMode }) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "10px",
        right: "10px",
        zIndex: 6,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <button
        onClick={onZoomIn}
        disabled={zoomLevel === 1}
        role="button"
        tabIndex={0}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          border: nightMode ? "2px solid #c2c4c2" : "2px solid #010101",
          backgroundColor: nightMode ? "#222" : "#fff",
          color: nightMode ? "#c2c4c2" : "#010101",
          cursor: zoomLevel === 1 ? "not-allowed" : "pointer",
          opacity: zoomLevel === 1 ? 0.5 : 1,
          fontSize: "20px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
          boxShadow: nightMode
            ? "0 2px 8px rgba(0,0,0,0.3)"
            : "0 2px 8px rgba(0,0,0,0.1)",
          lineHeight: 1,
          padding: 0,
        }}
        onMouseEnter={(e) => {
          if (zoomLevel !== 1) {
            e.target.style.transform = "scale(1.1)";
          }
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "scale(1)";
        }}
      >
        +
      </button>
      <button
        onClick={onZoomOut}
        role="button"
        tabIndex={0}
        disabled={zoomLevel === 4}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          border: nightMode ? "2px solid #c2c4c2" : "2px solid #010101",
          backgroundColor: nightMode ? "#222" : "#fff",
          color: nightMode ? "#c2c4c2" : "#010101",
          cursor: zoomLevel === 4 ? "not-allowed" : "pointer",
          opacity: zoomLevel === 4 ? 0.5 : 1,
          fontSize: "20px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
          boxShadow: nightMode
            ? "0 2px 8px rgba(0,0,0,0.3)"
            : "0 2px 8px rgba(0,0,0,0.1)",
          lineHeight: 1,
          padding: 0,
        }}
        onMouseEnter={(e) => {
          if (zoomLevel !== 4) {
            e.target.style.transform = "scale(1.1)";
          }
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "scale(1)";
        }}
      >
        −
      </button>
    </div>
  );
}

export default TournamentZoomControls;
